import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatomoTracker } from 'ngx-matomo';
import { GetDataService } from '../services/get-data.service';

@Component({
  selector: 'app-kalender',
  templateUrl: './kalender.component.html',
  styleUrls: ['./kalender.component.scss']
})
export class KalenderComponent implements OnInit {

  today = new Date().setHours(0, 0, 0, 0);
  liste = null;

  vorwort = {
    "id": 101,
    "name": "Vorwort",
    "autor": "Andreas Lau",
    "titel": "Vorwort",
    "bibelvers": "",
    "bibelstelle": ""
  }

  einleitung = {
    "id": 102,
    "name": "Einleitung",
    "autor": "Tabea Schönfelder",
    "titel": "Einleitung",
    "bibelvers": "",
    "bibelstelle": ""
  }

  constructor(
    public getDataService: GetDataService,
    private router: Router,
    private matomoTracker: MatomoTracker
    ) {
  }

  ngOnInit(): void {
    // Doppeltes Tracking
    //this.matomoTracker.setDocumentTitle('Adventskalender Übersicht');
    //this.matomoTracker.setCustomUrl(this.router.url);
    //this.matomoTracker.trackPageView();

  }

  checkDatum(id) {
    let datum = this.getDataService.liste.find(el => el.id === id);
    datum = datum.datum;
    datum = Date.parse(datum);
    if (this.today >= datum) {
      return true;
    } else { return false; }
  }

  heutigesDatum() {
    var today = new Date();
    return today.getDate() + "." + (today.getMonth() + 1) + "." + today.getFullYear();
  }

}
